'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoJSONFormat = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module opensearch/formats/geojson
 */

/**
 * Class to parse GeoJSON results
 * @constructor GeoJSONFormat
 * @implements {module:opensearch/formats.FormatInterface}
 */
var GeoJSONFormat = exports.GeoJSONFormat = function () {
  function GeoJSONFormat() {
    _classCallCheck(this, GeoJSONFormat);
  }

  _createClass(GeoJSONFormat, [{
    key: 'parse',

    /**
     * Parse the given JSON.
     * @param {string} text The JSON string to parse.
     * @returns {module:opensearch/formats.SearchResult} The parsed search result
     */
    value: function parse(text) {
      var result = JSON.parse(text);
      var records = result.features.map(function (item) {
        if (!Object.prototype.hasOwnProperty.call(item, 'id') && Object.prototype.hasOwnProperty.call(item.properties, 'id')) {
          return (0, _utils.assign)({
            id: item.properties.id
          }, item);
        }
        return item;
      });

      return {
        // TODO: parse properties of featurecollection
        records: records
      };
    }
  }]);

  return GeoJSONFormat;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/formats/geojson.js